/* eslint-disable */
const validate = values => {
  const errors = {};
  if (!values.currentPass) {
    errors.currentPass = 'Required';
  }
  if (!values.newPass) {
    errors.newPass = 'Required';
  }
  if (!values.confirmNewPass) {
    errors.confirmNewPass = 'Required';
  }
  if (values.newPass !== values.confirmNewPass) {
    errors.confirmNewPass = 'New password must be the same confirm new password'
  }
  // if (!values.email) {
  //   errors.email = 'Required'
  // }


  // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
  //   errors.email = 'Invalid email address'
  // }
  return errors;
};
const validateSignUpFacebook = values => {
  const errors = {};
  if (!values.username) {
    errors.username = 'Required';
  }

  if (!values.email) {
    errors.email = 'Required'
  }
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors;
};
const validateSignUp = values => {
  const errors = {};
  if (!values.username) {
    errors.username = 'Required';
  }
  if (!values.password) {
    errors.password = 'Required';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Required';
  }
  if (values.password !== values.confirmPassword) {
    errors.confirmNewPass = 'New password must be the same confirm new password'
  }
  if (!values.email) {
    errors.email = 'Required'
  }
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  return errors;
};
const validateForget = values => {
  const errors = {};
/*
	if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
	}
*/	
  if (!values.email) {
    errors.email = 'Required';
  }
  return errors

}
const validateSignIn = values => {
  const errors = {};
  if (!values.username) {
    errors.username = 'Required';
  }
  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
};

const validateChangePassword = values => {
  const errors = {};
  if (!values.password) {
    errors.password = 'Required';
    return errors;
  }
  if (values.password.length < 8) {
    errors.password = 'Must be 8 at least characters';
    return errors;
  }
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d,.;:]).+$/.test(values.password)) {
    errors.password = 'Must use at least 1 capital, 1 lower case, and 1 number';
    return errors;
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Required';
  }
  if (values.password != values.confirmPassword) {
    errors.confirmPassword = 'Must Match';
  }
  return errors;
}

const validateAddress = values => {

  console.tron.display({
    name: `validateAddress`,
    preview: ``,
    value: {
      state: values
    }
  })

  let errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
/*
  if (!values.street) {
    errors.street = 'Required';
  }
  if (!values.city) {
    errors.city = 'Required';
  }
  if (!values.state) {
    errors.state = 'Required';
  }
  if (!values.zip) {
    errors.zip = 'Required';
  } else if (values.zip.length < 3) {
    errors.zip = 'Zip/Postal Code is invalid'
  }
*/  
  if (!values.country) {
    errors.country = 'Required';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  }
  // else if (!/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(values.phone)) {
  //   errors.phone = 'Phone number is invalid'
  // }
  // if (values.zip.length != 5 && values.zip.length != 6) {
  // errors.confirmNewPass = 'Zip code must length 5 or 6 charactor'
  // }

  return errors;
};

export {
  validateForget,
  validate,
  validateSignUp,
  validateSignIn,
  validateChangePassword,
  validateAddress,
  validateSignUpFacebook
}
